<template>
  <div>
    <el-table
      :data="tableData"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      stripe
      size="mini"
    >
      <el-table-column type="selection" align="center" header-align="center" width="55"></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="userNo"
        label="用户账号"
        min-width="70"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="userName"
        label="中文姓名"
        min-width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="userNameEn"
        label="英文姓名"
        min-width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="mobileNumber"
        label="手机号码"
        min-width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="emailAddress"
        label="邮件地址"
        min-width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="fixedTelephone"
        label="固定电话"
        min-width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="userPost"
        label="职务"
        min-width="60"
      ></el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </div>
    </el-table>
  </div>
</template>
<script>
// import { } from '@api/projectManager/infoParticipant'
export default {
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data () {
    return {
      // 选中的数据
      multipleSelection: []
    }
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val
    }
  }
}
</script>
